import styled from "styled-components";

import { Card } from "@origin-digital/ods-core";

export type StyledCardProps = {
  maxWidth: string | number;
};

export const defaultStyleCardProps: StyledCardProps = {
  maxWidth: 650,
};

export const StyledCard = styled(Card)(({ maxWidth }: StyledCardProps) => ({
  "&&": {
    maxWidth,
    margin: "auto",
  },
}));
